import { Card } from "@components/ui/card";
import type { StoryType } from "@config";
import { useAppDispatch } from "@store";
import { closeDialog } from "@store/dialogs";
import { useState } from "react";
import type { CreateTarget } from "@/features/standalone-versions";
import type { IPage } from "@/types";
import { CreateStoryBody } from "./create-story-body";
import { CreateStoryFooter } from "./create-story-footer";
import { CreateStoryHeader } from "./create-story-header";

const DIALOG_ID = "create-story-dialog";

interface IProps {
  templateStory: IPage;

  withFolder?: boolean;
  forceUseTemplateSlides?: boolean;
  keepTemplateDesignSystem?: boolean;
  /** A story (default), or a standalone version; see features/standalone-versions. */
  createTarget?: CreateTarget;
  onSuccess?: (story: StoryType) => void;
}

export const CreateStoryDialog = ({
  templateStory,
  withFolder,
  forceUseTemplateSlides,
  keepTemplateDesignSystem,
  createTarget = "story",
  onSuccess,
}: IProps) => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [folder, setFolder] = useState<{ id: string; name: string }>({
    id: "",
    name: "",
  });
  const [name, setName] = useState<string>("");

  const handleClose = () => {
    dispatch(closeDialog(DIALOG_ID));
  };

  return (
    <Card>
      <CreateStoryHeader close={handleClose} createTarget={createTarget} />
      <CreateStoryBody
        name={name}
        setName={setName}
        folder={folder}
        setFolder={setFolder}
        withFolder={!!withFolder && createTarget !== "version"}
        createTarget={createTarget}
      />
      <CreateStoryFooter
        close={handleClose}
        name={name}
        templateStory={templateStory}
        folderId={folder.id}
        forceUseTemplateSlides={!!forceUseTemplateSlides}
        keepTemplateDesignSystem={keepTemplateDesignSystem}
        createTarget={createTarget}
        loading={loading}
        setLoading={setLoading}
        {...(onSuccess && { onSuccess })}
      />
    </Card>
  );
};

CreateStoryDialog.dialogId = DIALOG_ID;
